import React, { useState, useEffect } from "react";
import { Grid, Typography, Button, Box } from "@mui/material";
import { makeStyles } from "@mui/styles";
import { isEqual as _isEqual, cloneDeep as _cloneDeep } from "lodash";
import SessionService from "../../../../data/session-service";

const useStyles = makeStyles((theme) => ({
  addButton: {
    float: "right",
  },
  heading: {
    marginRight: theme.spacing(1),
  },
}));

const Session = (props) => {
  const classes = useStyles();
  const [sessions, setSessions] = useState([]);

  useEffect(() => {
    if (props.sessiondata) {
      setSessions(props.sessiondata);
    }
  }, [props.sessiondata]);

  return (
    <Box mt={2}>
      <Grid
        container
        alignItems="center"
        justifyContent="space-between"
        marginBottom={2}
      >
        <Typography variant="h6" className={classes.heading}>
          Traffic Filter Sessions
        </Typography>
      </Grid>
      <Grid container justifyContent="space-between">
        <Grid item xs={2}>
          Session Description
        </Grid>
        <Grid item xs={2}>
          Session Number
        </Grid>
        <Grid item xs={2}>
          Mirror Source
        </Grid>
        <Grid item xs={2}>
          Mirror Target
        </Grid>
        <Grid item xs={2}>
          Mirror Filter
        </Grid>
      </Grid>
      <Grid container mt={2}>
        {sessions.length > 0 &&
          sessions.map((session, index) => (
            <Grid container key={index} spacing={2} justifyContent="space-between">
              <Grid item xs={2}>
                {session.Description}
              </Grid>
              <Grid item xs={2}>
                {session.SessionNumber}
              </Grid>
              <Grid item xs={2}>
                {session.NetworkInterfaceId}
              </Grid>
              <Grid item xs={2}>
                {session.TrafficMirrorTargetId}
              </Grid>
              <Grid item xs={2}>
                {session.TrafficMirrorFilterId}
              </Grid>
            </Grid>
          ))}
      </Grid>
    </Box>
  );
};

export default Session;
